import { Component, OnInit, Inject, Optional } from '@angular/core';
import { FormControl, VERSION } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-inject-solar',
  templateUrl: './inject-solar.component.html',
  styleUrls: ['./inject-solar.component.scss']
})
export class InjectSolarComponent implements OnInit {
 public baseURL = environment.apiBase;
  version = VERSION;
  date = new Date();
  chosenYearDate: Date;
  chosenMonthDate: Date = new Date(2020,0,1);
  chosenSemesterDate: Date;
  chosenWeekDate: Date;
  chosenDate: Date;
  monthInputCtrl: FormControl = new FormControl(new Date(2020,0,1));
  public logo:any;
  visible = true;
  roleName: any;
  role: any;
  name: any;
  company_Name: any;

  constructor(@Inject(HeaderComponent) @Optional() private parent?: HeaderComponent,) {
    this.logo = localStorage.logo;
    this.role = localStorage.role;
    this.name = localStorage.name;
    this.company_Name = localStorage.company_name;


    if(this.role == '1') {
      this.roleName = 'admin';
    } else if(this.role == '2') {
      this.roleName = 'epc';
    }
    else if(this.role == '3') {
      this.roleName = 'wms';
    }
    else if(this.role == '4') {
      this.roleName = 'normal';
    }
    else if(this.role == '5') {
      this.roleName = 'slave_admin';
    }
    else if(this.role == '6') {
      this.roleName = 'ze';
    }
    else if(this.role == '7') {
      this.roleName = 'dg';
    }
  }

  ngOnInit() {
  }
// callSideMenu(){
//   this.parent.toggleNavbar();
// }
}
